<template>
	<div>
		<core-send-email-notification @notification:sent="$emit('email:sent')" />
	</div>
</template>

<script>
import CoreSendEmailNotification from "@/modules/core/components/CoreSendEmailNotification"

export default {
	components: {
		CoreSendEmailNotification
	}
}
</script>
